module.exports = __webpack_public_path__ + "images/category_lp/jewel/point3_4b10e6c0fb150bde4e5319b8939b3443.png";